import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';
import {MvsCoreService} from '../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../core/shared/object/service/observer.service';
import {NavigationItem} from '../../../../../core/shared/dto/navigation/navigation-item';
import {WidgetData} from '../../../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../../../core/shared/widget/service/widget.factory';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../../../core/shared/helper/widget-function-call-back-create';
import {UfFlowTypeDto} from '../../../model/dto/entity/uf-flow-type.dto';

@Component({
    selector: 'uf-flow-type-object-component',
    templateUrl: 'uf-flow-type-object.component.html',
    styleUrls: ['uf-flow-type-object.component.scss'],
    standalone: false
})
export class UfFlowTypeObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    dto: UfFlowTypeDto;

    fieldsWidget: WidgetData;
    objectRolesWidget: WidgetData;
    stepsWidget: WidgetData;

    navigationItems: NavigationItem[] = [
        {
            label: 'Übersicht',
            action: 'overview',
            tooltip: 'Übersicht des Flusstyps',
            icon: 'fa-regular fa-eye',
            toggleable: false,
            default: true
        },
        {
            label: 'Felder',
            action: 'fields',
            tooltip: 'Felder des Flusstyps',
            icon: 'fa-regular fa-list-check',
            toggleable: false,
            default: false
        },
        {
            label: 'Objektrollen',
            action: 'objectRoles',
            tooltip: 'Objektrollen des Flusstyps',
            icon: 'fa-regular fa-users',
            toggleable: false,
            default: false
        },
        {
            label: 'Schritte',
            action: 'steps',
            tooltip: 'Schritte des Flusstyps',
            icon: 'fa-regular fa-stairs',
            toggleable: false,
            default: false
        }
    ];

    private queryParamSubscription: Subscription;

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected override observerService: ObserverService,
        private route: ActivatedRoute
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.subscribeToNavItemQueryParam();
    }

    onObjectChanged() {
        if (!this.activeNavigationItems) {
            this.activeNavigationItems = this.navigationItems[0];
        }
        this.onNavigationItems.emit(this.navigationItems);
        this.createChildWidgets();
    }

    private subscribeToNavItemQueryParam(): void {
        this.queryParamSubscription = this.route.queryParams.subscribe(params => {
            const navItem = params['navItem'];
            if (navItem) {
                const found = this.navigationItems.find(item => item.action === navItem);
                if (found) {
                    this.activeNavigationItems = found;
                }
            }
        });
    }

    private createChildWidgets(): void {
        const flowTypeId = this.objectIdentifier.objectId;

        // --- Fields Widget ---
        const fieldsFilter = [
            FilterCriteria.create('e.typeId', FilterCriteria.cOperatorEqual, flowTypeId)
        ];
        this.fieldsWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'uf.flowType.object.fields.table',
            'Felder',
            'uf.UfFlowTypeField',
            fieldsFilter
        );
        const fieldsCreateFields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'typeId', fieldValue: flowTypeId}
        ];
        this.fieldsWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fieldsCreateFields);

        // --- Object Roles Widget ---
        const objectRolesFilter = [
            FilterCriteria.create('e.flowTypeId', FilterCriteria.cOperatorEqual, flowTypeId)
        ];
        this.objectRolesWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'uf.flowType.object.objectRoles.table',
            'Objektrollen',
            'uf.UfFlowTypeObjectRole',
            objectRolesFilter
        );
        const objectRolesCreateFields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'flowTypeId', fieldValue: flowTypeId}
        ];
        this.objectRolesWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(objectRolesCreateFields);

        // --- Steps Widget ---
        const stepsFilter = [
            FilterCriteria.create('e.flowTypeId', FilterCriteria.cOperatorEqual, flowTypeId)
        ];
        this.stepsWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'uf.flowType.object.steps.table',
            'Schritte',
            'uf.UfFlowTypeStep',
            stepsFilter
        );
        const stepsCreateFields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'flowTypeId', fieldValue: flowTypeId}
        ];
        this.stepsWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(stepsCreateFields);
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.queryParamSubscription?.unsubscribe();
    }
}
